import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpBaseService } from '@evento-ng/libs';
import { verifyEmailApi } from 'src/app/shared/constants/api.constants';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
})
export class VerifyEmailComponent implements OnInit {
  counter = 3;
  verified: boolean;
  isRequestFinished: boolean;
  errorMsg: string;
  constructor(
    private route: ActivatedRoute,
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.verifyEmail();
  }

  playCounter(): void {
    const counterRef = setInterval(() => {
      this.counter--;
      if (this.counter === 0) {
        clearInterval(counterRef);
        this.router.navigateByUrl('/auth/login');
      }
    }, 1000);
  }

  verifyEmail() {
    this.spinner.show();
    const id = this.route.snapshot.paramMap.get('id');
    return this.dataService
      .post(`${verifyEmailApi}/${id}/validate`, {})
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.isRequestFinished = true;
          this.verified = true;
          this.playCounter();
        },
        (error) => {
          this.errorMsg = error.error.message;
          this.isRequestFinished = true;
        }
      );
  }
}
